












































































































































































































import { Component, Vue, Emit, PropSync, Watch } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired } from '@/components/UI/Form/Validations';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_UnitCreate, GQL_IdentityCreate } from '@/queries/global';
import { GQL_createUnit } from '@/queries/__generated__/createUnit';
import { GQL_findUnitForCreateForm } from '@/queries/__generated__/findUnitForCreateForm';
import { GQL_allIdentificators, GQL_allIdentificators_allIdentificators } from '@/queries/__generated__/allIdentificators';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting_currentUnit, GQL_unitInvoiceSetting } from '@/queries/__generated__/unitInvoiceSetting';
import PhoneInput from '@/components/PhoneInput.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import merge from 'lodash/merge';
import uniqueId from 'lodash/uniqueId';
import { ALL_COUNTRIES } from '@/queries/Country';
import { GQL_allCountries_allCountries } from '@/queries/__generated__/allCountries';
import { postCityForZip } from '@/utils/postal-code';
import gql from 'graphql-tag';
import {
  unitAddressFragments,
  unitContactFragments,
  unitFragments,
} from '@/queries/unitFragments';

const ALL_IDENTIFICATORS = gql`
  query allIdentificators {
    allIdentificators {
      id
      name
      priority
      description
      country {
        code
        name
        phoneCode
      }
    }
  }
`;

const CREATE_UNIT = gql`
  mutation createUnit(
    $unit: UnitCreate!
  ) {
    createUnit(
      input: {
        unit: $unit
      }
    ) {
      unit {
        ...unitFragments,
        ...unitContactFragments,
        ...unitAddressFragments,
        closedDate,
        openedDate
      }
    }
  }
  ${unitFragments}
  ${unitContactFragments}
  ${unitAddressFragments}
`;

const FIND_UNIT_FOR_CREATE_FORM = gql`
  query findUnitForCreateForm(
    $identificator: String!, $value: String!
  ) {
    unitFind(
      identificator: $identificator
      value: $value
    ) {
      ...unitFragments,
      ...unitContactFragments,
      ...unitAddressFragments,
    }
  }
  ${unitFragments}
  ${unitContactFragments}
  ${unitAddressFragments}
`;

// I wish I could make unit optional but then I have problems with form
type identityForm = GQL_IdentityCreate & {
  existence: {
    pendingCheck: boolean;
    unit: {id?: number; name?: string};
    version: string;
  };
}

@Component({
  i18n: {
    messages: {
      en: {
        waitingForCheckingIdentety: "Just a second, checking if identity exist",
        unitExistsWithIdentity: "There already exists a unit with this identity",
        use: "Use",
      },
      nb: {
        waitingForCheckingIdentety: "Et øyeblikk mens vi sjekker om identifikatoren er i bruk",
        unitExistsWithIdentity: "Det er et annet selskap med denne identifikatoren",
        use: "Bruk",
      },
    },
  },
  components: {
    PhoneInput,
  },
})
export default class UnitForm extends Vue {
  @SmartQuery(ALL_COUNTRIES) private allCountries!: GQL_allCountries_allCountries[];
  @SmartQuery<UnitForm, GQL_allIdentificators>({
    query: ALL_IDENTIFICATORS,
    result() { this.createInitialIdentities() },
  }) private allIdentificators!: GQL_allIdentificators_allIdentificators[];
  @SmartQuery<UnitForm, GQL_unitInvoiceSetting>({
    query: UNIT_INVOICE_SETTINGS,
    result() { this.createInitialIdentities() },
  }) private currentUnit!: GQL_unitInvoiceSetting_currentUnit;

  @PropSync('isCompany', { type: Boolean, default: true }) public isCompanySync!: boolean;

  private created() {
    this.rules = {
      name: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Unit', 'name') }),
      } ],
      address: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Address.address') }),
      } ],
      city: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Address.city') }),
      } ],
      zip: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Address.zip') }),
      } ],
      country: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Address.country') }),
      } ],
      identity: {
        existence: {
          unitId: [],
          pendingCheck: [],
        },
        identificator: [ {
          validation: validateRequired(),
          message: i18n => i18n.t('Error.required', { field: i18n.t('Unit.firmaid') }),
        } ],
        value: [
          {
            validation: validateRequired(),
            message: i18n => i18n.t('Error.required', { field: i18n.t('Unit.firmaid') }),
          }, {
            validation: ({formElements, uid}) => {
              if (!uid) return true;
              const pendingCheck = (formElements.identity.existence?.pendingCheck || [])[uid];
              if (pendingCheck === undefined) return true;
              if (pendingCheck.dataValue === undefined) return true;

              return !pendingCheck.dataValue;
            },
            message: () => this.$t('waitingForCheckingIdentety'),
            triggerBy: [ ({ withSameUID }) => withSameUID('identity.existence.pendingCheck') ],
          }, {
            validation: ({formElements, uid}) => {
              if (!uid) return true;
              const unitId = (formElements.identity.existence?.unitId || [])[uid];
              if (unitId === undefined) return true;
              if (unitId.dataValue === undefined) return true;

              return !unitId.dataValue;
            },
            message: () => this.$t('unitExistsWithIdentity'),
            triggerBy: [ ({ withSameUID }) => withSameUID('identity.existence.unitId') ],
          },
        ],
      },
    };
  }

  private CREATE_UNIT = CREATE_UNIT;

  private identities: identityForm[] = [];

  private formData = {
    name: '',
    unofficialName: '',
    address: '',
    city: '',
    zip: '',
    countryCode: '',
  };

  private validForm = true;

  private get formDataForMutation(): GQL_UnitCreate {
    return {
      ...this.formData,
      isCompany: this.isCompanySync,
      identities: this.identities
        .map(identity => {
          return {
            ...identity,
            existence: undefined,
          };
        }),
    };
  }

  private rules: IRules = {};

  private get relevantIdentificators(): GQL_allIdentificators_allIdentificators[] {
    return this.allIdentificators.filter(i =>
      !i.country ||
      i.country.code === this.formData.countryCode,
    );
  }

  private findIdentificator(id: string): GQL_allIdentificators_allIdentificators | undefined {
    return this.allIdentificators
      .find(i => i.id == id);
  }

  private get phoneIdentificator(): GQL_allIdentificators_allIdentificators {
    return this.allIdentificators.find(i => i.name === 'PHONE')!;
  }

  private createInitialIdentities(): void {
    if (!this.currentUnit || !this.allIdentificators) return;
    if (this.identities.length > 0) return;

    this.formData.countryCode = this.currentUnit.unitSetting.unitInvoiceSetting.customerCountry.code;
    this.addIdentity({ identificatorId: this.allIdentificators.find((ident) => ident.name === 'EMAIL')!.id });
    this.addIdentity({ identificatorId: this.allIdentificators.find((ident) => ident.name === 'PHONE')!.id });
    if (this.isCompanySync) {
      const orgnrIdentificator = this.allIdentificators.find((ident) => ident.country?.code === this.formData.countryCode && ident.priority === 1);
      if (orgnrIdentificator) this.addIdentity({ identificatorId: orgnrIdentificator.id });
    }
  }

  @Watch('isCompanySync')
  private addOrgnrIdentityIfCompany(isCompany: boolean) {
    const orgnrIdentificator = this.allIdentificators.find(ident => ident.country?.code === this.formData.countryCode && ident.priority === 1);
    if (!orgnrIdentificator) return;

    if (isCompany) {
      const hasOrgnrIdentity = this.identities.some(identity => identity.identificatorId === orgnrIdentificator.id);

      if (!hasOrgnrIdentity) {
        this.addIdentity({ identificatorId: orgnrIdentificator.id });
      }
    } else {
      // We loop through this using `for` from the end to the start because
      // `removeIdentity` mutates the array, which then messes with the indexes.
      for (let index = (this.identities.length - 1); index >= 0 ; index--) {
        const identity = this.identities[index];

        if (identity.identificatorId === orgnrIdentificator.id && !identity.value) {
          this.removeIdentity(index);
        }
      }
    }
  }

  private addIdentity(
    override: {identificatorId?: string; value?: string; phoneCode?: string; countryCode?: string},
  ): void {
    this.identities.push(merge({
      identificatorId: '',
      value: '',
      phoneCode: '',
      countryCode: this.formData.countryCode || '',
      existence: {
        pendingCheck: false,
        unit: {},
        version: 'initial',
      },
    }, override));
  }

  private removeIdentity(index: number): void {
    this.identities.splice(index, 1);
  }

  private async fillCity(): Promise<void> {
    const city = await postCityForZip(this.$apollo, this.formData);

    if(city) this.formData.city = city;
  }

  @Emit()
  private unitCreated(store: InMemoryCache, { data }: { data: GQL_createUnit }) {
    this.$sMessage.success(this.$t('Company.Setting.saveSuccess'));
    return data.createUnit!.unit!;
  }

  private identityChanged(identity: identityForm) {
    const version = uniqueId();
    this.$set(identity.existence, 'pendingCheck', true);
    this.$set(identity.existence, 'unit', {});
    this.$set(identity.existence, 'version', version);

    this.formatIdentity(identity);

    this.$apollo
      .query({
        query: FIND_UNIT_FOR_CREATE_FORM,
        fetchPolicy: 'no-cache',
        variables: {
          identificator: this.findIdentificator(identity.identificatorId)?.name,
          value: identity.value,
        },
      })
      .then(({data}: { data: GQL_findUnitForCreateForm }) => {
        if (version != identity.existence.version) {
          // If we fire two requests almost simultaneously we only want the response
          // of the latest request to affect the validation / state of the form.
          // console.log(`different version doing nothing`, {version: version, a_version: identity.existence.version});
          return;
        }

        this.$set(identity.existence, 'pendingCheck', false);
        this.$set(identity.existence, 'unit', data.unitFind || {});
      });
  }

  private formatIdentity(identity: identityForm) {
    const identificatorName = this.findIdentificator(identity.identificatorId)?.name;

    identity.value = identity.value.replace(/\s/g, '');

    if (identificatorName === 'NO:ORGNR') {
      identity.value = identity.value.replace(/[^0-9]/g, '');
    }

    if (identificatorName?.match(/VAT|IBAN|BIC|ACCNT-SWIFT/)) {
      identity.value = identity.value.toUpperCase();
    } else if (identificatorName?.match(/WEB|EMAIL/)) {
      identity.value = identity.value.toLowerCase();
    }
  }
}
